module.exports = __webpack_public_path__ + "img/capelo_logo_ani_200_60_gray.1ebdf09e.gif";